import styled from "styled-components";

export const SpacerBox = styled.div<{height: string}>`
    height: ${({height}) => height};
`;
